import { UniqueFeatureName } from './types';

/**
 * This map groups the feature names together to ensure that when you hover over a feature name in a column on the Summary page,
 * the corresponding feature in other packages will be highlighted.
 */

const ExperimentUniqFeatureNames = {
  grow_2792_create_question_limit: [
    'create_question_limit',
    'unlimited_questions',
    'grow_2792_unlimited_questions',
    'grow_2792_basic_create_question_limit',
  ],
  grow_2792_user: [
    'grow_2792_single_user',
    'grow_2792_team_collaboration_user',
    'grow_2792_advanced_team_collaboration_user',
    'grow_2792_forms_advantage_team',
  ],
  grow_2792_question_types: [
    'grow_2792_forms_question_types',
    'grow_2792_all_question_types_t1_t2',
    'grow_2792_all_question_types_t3',
    'grow_2792_basic_question_types',
  ],
  grow_2792_survey_branding: ['grow_2792_create_custom_theme_enabled', 'survey_branding'],
};

const uniqueFeatureNameMap: UniqueFeatureName = {
  contributor_seats: ['contributor_seats', 'advanced_collaboration'],
  response_count: [
    'base_response_count',
    'unlimited_responses',
    'num_free_responses',
    'grow_2792_custom_response_limits',
    'grow_2792_base_response_count',
    'grow_2792_basic_base_response_count',
  ],
  support: [
    'priority_email_support',
    'phone_support',
    'email_support',
    'grow_2792_support',
    'grow_2792_priority_email_support',
    'grow_2792_phone_support',
  ],
  skip_logic: ['create_piping_enabled', 'skip_logic', 'grow_2792_skip_logic'],
  statistical_significance: ['statistical_significance', 'text_analysis'],

  // ExperimentUniqFeatureNames should always be last
  ...ExperimentUniqFeatureNames,
};

export default uniqueFeatureNameMap;
